module.exports = __webpack_public_path__ + "media/documents/gutschein_entwerten-1dc29f071500e8a67dd7ef73badb9bfd.pdf";